import { Controller } from "@hotwired/stimulus";
import { inviteRowMatches } from "../utils/manage_invites_filter";

const FILTER_KEYS = ["source", "status", "intermediary", "buyer", "sector", "country"];

export default class extends Controller {
  static targets = ["row", "search", "reset", "noResults"];

  connect() {
    this.apply();
  }

  filterChanged() {
    this.apply();
  }

  apply() {
    const filters = Object.fromEntries(
      FILTER_KEYS.map((key) => [
        key,
        [...this.element.querySelectorAll(`input[name="${key}[]"]:checked`)].map((cb) => cb.value),
      ])
    );
    const query = this.hasSearchTarget ? this.searchTarget.value.trim().toLowerCase() : "";

    this.rowTargets.forEach((row) => {
      row.hidden = !inviteRowMatches(row.dataset, filters, query);
    });

    if (this.hasNoResultsTarget) {
      this.noResultsTarget.hidden = this.rowTargets.some((row) => !row.hidden);
    }

    if (this.hasResetTarget) {
      const active = query !== "" || FILTER_KEYS.some((key) => filters[key].length > 0);
      this.resetTarget.classList.toggle("hidden", !active);
    }

    this.element.dispatchEvent(
      new CustomEvent("manage-invites:filtered", { bubbles: true })
    );
  }
}
